import React, { useState } from 'react';
import { Link } from 'gatsby';
import Modal from '@codedrop/modal/esm/modal';
import Form from '@codedrop/form/esm/form-dynamic';
import setHTML from '@codedrop/utils/esm/utils';

const MainMenu = ({
  mainMenu
}) => {
  const [modalState, setModalState] = useState(false);
  return /*#__PURE__*/React.createElement("div", {
    className: "main-menu"
  }, /*#__PURE__*/React.createElement("nav", {
    className: "main-menu__nav"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "main-menu__list"
  }, mainMenu.items && mainMenu.items.length > 0 ? mainMenu.items.map((item, index) => {
    if (item.external) {
      return /*#__PURE__*/React.createElement("li", {
        className: "main-menu__item",
        key: "main-menu-".concat(index)
      }, /*#__PURE__*/React.createElement("a", {
        href: item.link,
        className: "main-menu__link",
        target: "_blank",
        rel: "noopener noreferrer"
      }, item.linkText));
    } else {
      return /*#__PURE__*/React.createElement("li", {
        className: "main-menu__item",
        key: "main-menu-".concat(index)
      }, /*#__PURE__*/React.createElement(Link, {
        to: item.link,
        activeClassName: "main-menu__link--active",
        className: "main-menu__link"
      }, item.linkText));
    }
  }) : ''), mainMenu.ctaLink ? /*#__PURE__*/React.createElement("a", {
    href: mainMenu.ctaLink,
    className: "button"
  }, mainMenu.cta) : /*#__PURE__*/React.createElement(Modal, {
    buttonText: mainMenu.cta,
    title: mainMenu.modalContent.modalTitle,
    modalState: modalState,
    setModalState: setModalState,
    id: "modal-".concat(mainMenu.modalContent.formName)
  }, /*#__PURE__*/React.createElement(Form, {
    modifierClass: mainMenu.modalContent.formModifierClass,
    formName: mainMenu.modalContent.formName,
    formSubmitText: mainMenu.modalContent.formSubmitText,
    formFields: mainMenu.modalContent.formFields,
    formSuccess: mainMenu.modalContent.formSuccess,
    formFail: mainMenu.modalContent.formFail,
    callBack: () => {
      setModalState(false);
    }
  }))));
};

MainMenu.displayName = 'MainMenu';
MainMenu.defaultprops = {
  mainMenu: {
    items: []
  }
};
export default MainMenu;